var _circle, _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfilePicture(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 25,
    fill: "#ffadd1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ffadd1",
    d: "M13 13h24v24H13z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6,
    stroke: "#EC0E6E",
    strokeWidth: 1.938,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.5 24.5a6.458 6.458 0 100-12.917 6.458 6.458 0 000 12.917zM36.595 37.417c0-5-4.973-9.042-11.095-9.042-6.122 0-11.095 4.043-11.095 9.042"
  }))));
}
export default __webpack_public_path__ + "8a46d46747097ecd8118b47a97facbd8.svg";
export { SvgProfilePicture as ReactComponent };